import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../../store/root-reducer';

import KeyOfferingsStep from './key-offerings-step';

interface KeyOfferingsStepContainerProps {
  handleModalClose: () => void;
  saveCurrentStepDetails?: (payload: any) => void;
}

const KeyOfferingsStepContainer: React.FC<KeyOfferingsStepContainerProps> = ({
  handleModalClose,
  saveCurrentStepDetails,
}) => {
  const {
    data,
    data: { services },
  } = useSelector((state: RootState) => state?.sequence?.generateAiSeqModal);

  return (
    <KeyOfferingsStep
      handleModalClose={handleModalClose}
      services={services}
      aiSeqData={data}
      saveCurrentStepDetails={saveCurrentStepDetails}
    />
  );
};

export default memo(KeyOfferingsStepContainer);
